import styled from 'styled-components'
import { FontSize1, FontSize10, FontSize2, FontSize3, NolKoma7to1rem } from "../../GlobalStyles";

export const DetailWrapper = styled.div`
    /* background-color: greenyellow; */
    max-width: 1500px;
    margin: 2rem auto 0;
    @media (min-width: 800px){
        margin-top: 3rem;
    }
    @media (min-width: 1200px){
        margin-top: 5rem;
    }
`
export const TopDetail = styled.div`
    display: grid;
    gap: 2rem;
    width: 90%;
    margin: 0 auto;
    @media (min-width: 800px) {
        grid-template-columns: 1fr 1fr;
    }
`
export const ImageWrapper = styled.div`
    display: grid;
    gap: 10px;
    /* background-color: red; */
    @media (min-width: 1000px) {
        grid-auto-flow: column;
        justify-content: start;
    }
`
export const BigImage = styled.div`
    background-image: url(${({bgImg}) => bgImg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 350px;
    width: 60%;
    margin: 0 auto;
    border-radius: 10px;
    max-width: 500px;
    max-height: 600px;
    @media (min-width: 450px) {
        width: 280px;
    }
    @media (min-width: 650px) {
        width: 350px;
        height: 500px;
    }
    @media (min-width: 650px) {
        height: 400px;
        width: 320px;
    }
    @media (min-width: 1000px){
        grid-column: 2 / 3;
        /* width: 350px; */
        width: 35vw;
        height: 50vw;
    }
`
export const ImageSelection = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 10px;
    width: 80%;
    max-width: 330px;
    margin: 0 auto;
    @media (min-width: 1000px){
        grid-column: 1 / 2;
        align-items: start;
        align-content: start;
        grid-auto-flow: row;
        width: 60px;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
    }
    .active {
        border: 1px solid black;
    }
`
export const DescWrapper = styled.div`
    font-size: ${FontSize1};
    h4 {
        margin: 1rem 0 1.5rem;
    }
`
export const Size = styled.div`
    font-size: ${FontSize1};
    p {
        font-weight: bold;
        svg {
            font-size: ${FontSize3};
            margin-left: 10px;
        }
    }
    & > p:last-child {
        cursor: pointer;
    }
`
export const SizeContainer = styled.div`
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    gap: 5px;
    margin: 5px 0;
`
export const SizeItem = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.4);
    background-color: transparent;
    padding: 7px;
    font-size: ${FontSize1};
    transition: background-color 500ms, color 500ms;
    cursor: pointer;
    &:hover {
        background-color: black;
        color: white;
    }
`
export const Quantity = styled.div`
    font-size: ${FontSize1};
    h4 {
        margin-bottom: 5px;
    }
`
export const BoxCount = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 40px;
    width: 120px;
    @media (min-width: 768px) {
        height: 50px;
        width: 150px;
    }
    svg {
        font-size: ${FontSize1};
        cursor: pointer;
    }
    p {
        font-size: ${FontSize2};
    }
`
export const Button = styled.button`
    background-color: black;
    color: white;
    border: none;
    outline: none;
    cursor: pointer;
    text-transform: uppercase;
    font-weight: bold;
    width: 100%;
    margin-top: 1.5rem;
    padding: 1rem 0;
    border-radius: 5px;
`
export const SosmedWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 2rem auto 0;
    font-size: ${FontSize10};
    max-width: 400px;
    & > svg:not(:last-child){
        margin-right: 12px;
    }
`
export const BottomDetail = styled.div`
    /* background-color: lightgreen; */
    margin: 4rem auto 0;
    width: 97%;
    max-width: 800px;
`
export const Tabs = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 10px;
    font-size: ${NolKoma7to1rem};
    justify-items: center;
    align-items: center;
    p {
        color: rgba(0, 0, 0, 0.6);
        position: relative;
        cursor: pointer;
        text-align: center;
        &.active {
            color: rgba(0, 0, 0, 1);
            &::after {
                content: '';
                display: block;
                width: 100%;
                height: 1px;
                background-color: #000;
                transition: width 500ms ease;
                position: absolute;
                left: 0;
                bottom: -5px;
            }
            @media (min-width: 800px) {
                color: white;
                background-color: black;
                padding: 10px 1.5rem;
                border-radius: 6px;
            }
        }
        &::after {
            content: '';
            display: block;
            width: 0;
            height: 1px;
            background-color: #000;
            transition: width 500ms ease;
            position: absolute;
            left: 0;
            bottom: -5px;
        }
        &:hover::after {
            width: 100%;
        }
        @media (min-width: 650px) {
            font-size: ${FontSize1};
        }
    }
`